async function addToCart(variantId, quantity = 1) {
  let formData = {
    items: [
      {
        id: parseFloat(variantId),
        quantity: 1,
      },
    ],
  };

  const cartAddResponse = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });

  const cartAdd = await cartAddResponse.json();

  if (cartAdd.status == 422) {
    Toastify({
      text: cartAdd.description,
      duration: 2000,
      newWindow: true,
      close: true,
      gravity: "top", // `top` or `bottom`
      position: "center", // `left`, `center` or `right`
      stopOnFocus: true, // Prevents dismissing of toast on hover
      style: {
        background: "#3c413a",
        color: "white",
      },
    }).showToast();
    return;
  }

  if (window.location.href.includes("/cart")) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
  window.refreshCart("");
}

(function () {
  const selectors = {
    // swatches
    thumbnail: ".thumbnail",
    swatches: ".collection_swatches a",
    swatchesToggle: "[data-toggle-hidde-swatches]",
    thumbnailImage: ".product_image .image-element__wrap img",

    // quick add
    quickAddButton: "[data-quick-add-to-cart]",
    quickAddButtonsWrapper: ".thumbnail-overlay__button--quick-add",
    quidkAddSelect: "select.quick-add__select",
  };

  const thumbnails = document.querySelectorAll(selectors.thumbnail);

  for (const thumb of thumbnails) {
    if (thumb.querySelector(selectors.swatches)) {
      initProductCardSwatches(thumb);
    }

    initProductCardQuickAdd(thumb);
  }

  document
    .querySelectorAll(".swiper--search-products .thumbnail")
    .forEach((thumb) => {
      initProductCardQuickAdd(thumb);
    });

  function initProductCardSwatches(thumb) {
    const swatchesToggle = thumb.querySelector(selectors.swatchesToggle);

    thumb.querySelectorAll(selectors.swatches).forEach((swatch) => {
      swatch.addEventListener("click", (e) => {
        e.preventDefault();
        const productLink = swatch.getAttribute("href");

        const cardType = swatch.closest(".gallery-cell")
          ? "product-card-slider"
          : "product-card";

        fetch(`${productLink}?view=card&section_id=${cardType}`)
          .then((res) => res.text())
          .then((data) => {
            const newCard = new DOMParser()
              .parseFromString(data, "text/html")
              .body.querySelector(selectors.thumbnail);

            const currentCard = swatch.closest(selectors.thumbnail);

            currentCard.innerHTML = newCard.innerHTML;
            initProductCardSwatches(currentCard);
            window.imageFunctions.showSecondaryImage();
            initProductCardQuickAdd(currentCard);
          });
      });

      const swatchdataSrc = swatch
        .closest(selectors.thumbnail)
        .querySelector(selectors.thumbnailImage)
        .getAttribute("data-src");

      let currentImage = swatchdataSrc
        ? swatchdataSrc.replace("_1600x", "_400x")
        : swatch
            .closest(selectors.thumbnail)
            .querySelector(selectors.thumbnailImage)
            .getAttribute("src")
            .replace("_1600x", "_400x");

      swatch.addEventListener("mouseenter", (e) => {
        const image = swatch.dataset.image;
        const imageElement = swatch
          .closest(selectors.thumbnail)
          .querySelector(selectors.thumbnailImage);

        imageElement.removeAttribute("srcset");
        imageElement.setAttribute("src", image);
      });

      swatch.addEventListener("mouseleave", (e) => {
        const imageElement = swatch
          .closest(selectors.thumbnail)
          .querySelector(selectors.thumbnailImage);

        imageElement.setAttribute("src", currentImage);
        imageElement.removeAttribute("srcset");
      });
    });

    if (!swatchesToggle) return;
    swatchesToggle.addEventListener("click", (e) => {
      e.preventDefault();
      swatchesToggle.closest(".collection_swatches").classList.add("expanded");
      swatchesToggle.classList.add("hide");
    });
  }

  async function initProductCardQuickAdd(thumb) {
    const quickAddButtons = thumb.querySelectorAll(selectors.quickAddButton);

    const quickAddButtonsWrapper = thumb.querySelectorAll(
      selectors.quickAddButtonsWrapper,
    );

    if (quickAddButtons.length == 0) return;

    quickAddButtons.forEach((button) => {
      button.addEventListener("click", async (e) => {
        e.preventDefault();
        if (!button.dataset.variantId) return;

        const variantId = button.dataset.variantId;

        button.dataset.loading = true;
        await addToCart(variantId);
        button.removeAttribute("data-loading");
      });
    });

    if (quickAddButtonsWrapper.length == 0) return;
    quickAddButtonsWrapper.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        button.toggleAttribute("open");
      });
    });

    const quickAddSelect = thumb.querySelector(selectors.quidkAddSelect);
    if (quickAddSelect) {
      quickAddSelect.addEventListener("change", async (e) => {
        const variantId = quickAddSelect.value;

        await addToCart(variantId);
        quickAddSelect.selectedIndex = 0;
      });
    }
  }

  async function hydrateSwatches(newThumb) {
    const destinationSwatches = newThumb.querySelector(".collection_swatches");

    if (!destinationSwatches) return;

    const handle = newThumb.dataset.handle;
    const response = await fetch(`/products/${handle}?view=swatches`);

    if (!response.ok) {
      throw new Error(`Unable to load swatches for ${handle}`);
    }

    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, "text/html");
    const sourceSwatches = documentFragment.querySelector(
      ".collection_swatches",
    );

    if (!sourceSwatches) return;

    destinationSwatches.innerHTML = sourceSwatches.innerHTML;
    initProductCardSwatches(newThumb);
  }

  async function hydrateSwatchesInBatches(thumbnails, batchSize = 6) {
    for (let index = 0; index < thumbnails.length; index += batchSize) {
      const batch = thumbnails.slice(index, index + batchSize);

      const results = await Promise.allSettled(
        batch.map((thumbnail) => hydrateSwatches(thumbnail)),
      );

      results.forEach((result) => {
        if (result.status === "rejected") {
          console.warn("Swatch hydration failed:", result.reason);
        }
      });
    }
  }

  document.addEventListener("loadMoreProducts", async (e) => {
    const newThumbs = Array.from(e.detail.thumbnails);

    newThumbs.forEach((thumbnail) => {
      initProductCardQuickAdd(thumbnail);
    });

    await hydrateSwatchesInBatches(newThumbs, 6);
  });

  document.addEventListener("init:cart-drawer-thumbs", async (e) => {
    const newThumbs = e.detail.thumbnails;
    for (const newThumb of newThumbs) {
      initProductCardQuickAdd(newThumb);
    }
  });

  document.addEventListener("search:loaded", async (e) => {
    const { results, resultsContainer } = e.detail;
    const thumbnails = resultsContainer.querySelectorAll(`.thumbnail`);

    for (const newThumb of thumbnails) {
      initProductCardQuickAdd(newThumb);
    }
  });

  document.addEventListener("recentlyViewed:loaded", (e) => {
    const newThumbs = document.querySelectorAll(
      `${e.detail.parent} .thumbnail`,
    );

    if (newThumbs.length <= 4) {
      window.recentlyViewed.unload();
    }
    setTimeout(() => {
      for (const newThumb of newThumbs) {
        initProductCardQuickAdd(newThumb);
      }
    }, 1000);

    updateSliderArrows(document.querySelector(e.detail.parent));
  });

  document.addEventListener("productRecommendations:loaded", (e) => {
    const newThumbs = document.querySelectorAll(
      `${e.detail.sectionClass} .thumbnail`,
    );
    for (const newThumb of newThumbs) {
      initProductCardQuickAdd(newThumb);
    }
  });

  document.addEventListener("productRecommendationsSlider:loaded", (e) => {
    updateSliderArrows(document.querySelector(e.detail.sectionClass));
  });

  document.addEventListener("crosssell-slider:init", (e) => {
    const slider = e.detail.el;
    updateSliderArrows(slider);
  });

  document.addEventListener("product-thumbs-slider:loaded", (e) => {
    const slider = e.detail.el;
    updateSliderArrows(slider);
  });

  document.addEventListener("vendor-slider:init", (e) => {
    const slider = e.detail.el;
    updateSliderArrows(slider);
  });

  document.addEventListener("product-slider:init", (e) => {
    const slider = e.detail.el;
    updateSliderArrows(slider);
  });

  document.addEventListener("editors-pick-slider:init", (e) => {
    const slider = e.detail.el;
    updateSliderArrows(slider);
    console.log("updating editors pick");
  });

  function updateSliderArrows(slider) {
    slider.querySelectorAll(".flickity-button").forEach((button) => {
      button.innerHTML = `
      <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 89.37 67.55">
        <defs>
          <style>
            .cls-1 {
              fill: #cc4d28;
              stroke: #cc4d28;
              stroke-miterlimit: 10;
            }
          </style>
        </defs>
        <g id="Layer_1-2" data-name="Layer 1">
          <path class="cls-1" d="M2.93,15.82c13.96,15.16,24.51,27.33,33.26,45.97,0,.01.01.02.02.03.08.17.17.34.26.51.01.02.02.04.04.06.89,1.58,2.24,2.9,3.99,3.75,1.03.49,2.11.78,3.23.87.02,0,.04,0,.06,0,.2.01.41.02.62.03,0,0,0,0,0,0s0,0,0,0c.21,0,.41,0,.62-.02.02,0,.04,0,.06,0,1.12-.08,2.21-.36,3.24-.84,1.76-.82,3.13-2.14,4.03-3.71.01-.02.02-.04.03-.06.09-.17.18-.34.27-.51,0-.01.01-.02.02-.03,8.92-18.56,19.59-30.63,33.69-45.66,3.1-3.3,3.33-8.28.56-11.85-.29-.38-.62-.74-.97-1.06-1.69-1.58-3.89-2.46-6.21-2.47-2.53-.01-4.97,1.04-6.71,2.88-11.2,11.94-20.42,22.19-28.51,35.1C36.58,25.83,27.46,15.49,16.37,3.45c-1.71-1.86-4.15-2.94-6.68-2.95h0c-2.31-.01-4.53.85-6.23,2.41-.35.32-.68.68-.98,1.05C-.32,7.51-.13,12.5,2.93,15.82Z"/>
        </g>
      </svg>`;
    });
    slider.closest(".shopify-section").classList.add("slider-buttons-updated");
  }
})();

(function () {
  const selectors = {
    videoThumb: ".product-gallery__custom-video-thumb",
    galleryVideoThumb: ".gallery-cell.product-gallery__thumbnail",
  };

  const videoThumb = document.querySelector(selectors.videoThumb);

  if (!videoThumb) return;

  const videoId = videoThumb.dataset.id;

  videoThumb.addEventListener("click", (e) => {
    e.preventDefault();
    const galleryVideoThumb = document.querySelector(
      `${selectors.galleryVideoThumb}[data-id="${videoId}"]`,
    );
    galleryVideoThumb.click();
  });
})();

(function () {
  const selectors = {
    clickToZoom: ".image__container--click-to-zoom",
  };

  const clickToZoomEls = document.querySelectorAll(selectors.clickToZoom);

  if (clickToZoomEls.length == 0) return;

  clickToZoomEls.forEach((clickToZoom) => {
    clickToZoom.addEventListener("click", (e) => {
      e.preventDefault();
      clickToZoom.classList.remove("inactive");
    });

    clickToZoom.addEventListener("mouseleave", (e) => {
      e.preventDefault();
      clickToZoom.classList.add("inactive");
    });
  });
})();

(function () {
  const selectors = {
    stickyCartButton: ".sticky-cart__add-to-cart",
    sizeOptions: ".sticky-cart__options-wrapper--size",

    purchaseDetails: ".purchase-details",

    elToObserve: ".shopify-section--recently-viewed-products",
    elToObserveMobile: ".purchase-details",
    stickyEl: ".sticky-cart",
    stickyClass: "stick",
    optionWrapper: ".sticky-cart__options-wrapper",
  };

  const optionWrapper = document.querySelectorAll(selectors.optionWrapper);

  if (optionWrapper.length == 0) return;

  optionWrapper.forEach((wrapper) => {
    wrapper.addEventListener("click", (e) => {
      const type = wrapper.dataset.optionsType;
      optionWrapper.forEach((_wrapper) =>
        _wrapper.dataset.optionsType != type
          ? _wrapper.removeAttribute("open")
          : null,
      );
      wrapper.getAttribute("open") == "true"
        ? wrapper.removeAttribute("open")
        : wrapper.setAttribute("open", "true");
    });
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".sticky-cart__options-wrapper"))
      optionWrapper.forEach((w) => w.removeAttribute("open"));

    setTimeout(() => {
      if (e.target.closest("label"))
        optionWrapper.forEach((w) => w.removeAttribute("open"));
    }, 150);
  });

  const stickyCartButton = document.querySelector(selectors.stickyCartButton);

  if (!stickyCartButton) return;

  document
    .querySelectorAll(`${selectors.sizeOptions} input[type='radio']`)
    .forEach((input) => {
      input.addEventListener("change", (e) => {
        document.querySelector(
          `${selectors.sizeOptions} .selected-value`,
        ).innerText = e.target.value;
      });
    });

  stickyCartButton.addEventListener("click", async (e) => {
    e.preventDefault();
    const selectedVariant = document.querySelector(
      `${selectors.sizeOptions} input[type='radio']:checked`,
    ).dataset.variantId;

    if (selectedVariant) {
      stickyCartButton.dataset.loading = true;
      await addToCart(selectedVariant);
      stickyCartButton.removeAttribute("data-loading");
    }
  });

  const elementToObserve = document.querySelector(selectors.elToObserve);
  const elementToObserveMobile = document.querySelector(
    selectors.elToObserveMobile,
  );
  const elementToStick = document.querySelector(selectors.stickyEl);
  // const makeFormSticky = function (entries) {};
  const stickyFormObserver = new IntersectionObserver(
    (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        elementToStick.classList.add(selectors.stickyClass);
      } else {
        elementToStick.classList.remove(selectors.stickyClass);
      }
    },
    {
      root: null,
      threshold: 0.01,
    },
  );
  stickyFormObserver.observe(elementToObserve);

  const stickyFormObserverMobile = new IntersectionObserver(
    (entries) => {
      const [entry] = entries;

      if (entry.boundingClientRect.top > window.scrollY) return;

      if (entry.isIntersecting) {
        elementToStick.classList.remove(selectors.stickyClass);
      } else {
        elementToStick.classList.add(selectors.stickyClass);
      }
    },
    {
      root: null,
      threshold: 0.01,
    },
  );
  stickyFormObserverMobile.observe(elementToObserveMobile);
})();

// Converting description tabs to accordions

(function () {
  const selectors = {
    descriptionTabs: ".product-description .tabs a",
    descriptionTabContent: ".product-description .tabs-content li",
    rightDesc: ".product-description .RightDesc",
    productCollapsibles: ".product-description__collapsibles",
  };

  const descriptionTabs = document.querySelectorAll(selectors.descriptionTabs);
  const productCollapsibles = document.querySelector(
    selectors.productCollapsibles,
  );

  if (descriptionTabs.length == 0) return;

  const dropdownArrow = `<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 89.37 67.55">
        <defs>
          <style>
            .cls-1 {
              fill: #cc4d28;
              stroke: #cc4d28;
              stroke-miterlimit: 10;
            }
          </style>
        </defs>
        <g id="Layer_1-2" data-name="Layer 1">
          <path class="cls-1" d="M2.93,15.82c13.96,15.16,24.51,27.33,33.26,45.97,0,.01.01.02.02.03.08.17.17.34.26.51.01.02.02.04.04.06.89,1.58,2.24,2.9,3.99,3.75,1.03.49,2.11.78,3.23.87.02,0,.04,0,.06,0,.2.01.41.02.62.03,0,0,0,0,0,0s0,0,0,0c.21,0,.41,0,.62-.02.02,0,.04,0,.06,0,1.12-.08,2.21-.36,3.24-.84,1.76-.82,3.13-2.14,4.03-3.71.01-.02.02-.04.03-.06.09-.17.18-.34.27-.51,0-.01.01-.02.02-.03,8.92-18.56,19.59-30.63,33.69-45.66,3.1-3.3,3.33-8.28.56-11.85-.29-.38-.62-.74-.97-1.06-1.69-1.58-3.89-2.46-6.21-2.47-2.53-.01-4.97,1.04-6.71,2.88-11.2,11.94-20.42,22.19-28.51,35.1C36.58,25.83,27.46,15.49,16.37,3.45c-1.71-1.86-4.15-2.94-6.68-2.95h0c-2.31-.01-4.53.85-6.23,2.41-.35.32-.68.68-.98,1.05C-.32,7.51-.13,12.5,2.93,15.82Z"></path>
        </g>
      </svg>`;

  const accordionMarkup = (header, details, open = false) => {
    return `<details ${open ? "open" : ""}>
              <summary>${header} ${dropdownArrow}</summary>
              <div class="collapsible-text">
                ${details}
              </div>
            </details>`;
  };

  descriptionTabs.forEach((tab) => {
    const tabHeader = tab.innerText.trim();
    const tabHref = tab.getAttribute("href").replace("#", "");

    if (
      !document.querySelector(
        `${selectors.descriptionTabContent}[id="${tabHref}"]`,
      )
    )
      return;

    const tabDetails = document.querySelector(
      `${selectors.descriptionTabContent}[id="${tabHref}"]`,
    ).innerHTML;

    let open = false;
    if (tabHeader.toLowerCase().includes("video")) open = true;

    const accordion = accordionMarkup(tabHeader, tabDetails, open);

    productCollapsibles.innerHTML += accordion;
  });
})();

class SearchCollectionList extends HTMLElement {
  constructor() {
    super();

    this.searchQuery = this.getAttribute("data-search-query");
    this.searchURL = this.getAttribute("data-search-url");
  }

  connectedCallback() {
    const url = `${this.searchURL}/suggest?q=${this.searchQuery}&section_id=search-collection-list`;

    fetch(url)
      .then((res) => res.text())
      .then((data) => {
        this.innerHTML = data;

        const parsedData = new DOMParser().parseFromString(data, "text/html");
        const count = parseFloat(
          parsedData.querySelector("[data-count]").getAttribute("data-count"),
        );

        const addon = parseFloat(
          document
            .querySelector("#CollectionSearchCount")
            .getAttribute("data-addon"),
        );

        if (count + addon > 0) {
          document.querySelector("#CollectionSearchCount").innerText =
            ` (${count + addon})`;
        }
      });
  }
}

if (!customElements.get("search-collection-list")) {
  customElements.define("search-collection-list", SearchCollectionList);
}

document.addEventListener("variantChange", (event) => {
  const { variant, selector } = event.detail || {};
  const variantIdField = selector?.variantIdField;

  if (!variant || !variantIdField) return;

  requestAnimationFrame(() => {
    variantIdField.value = String(variant.id);

    variantIdField.dispatchEvent(new Event("change", { bubbles: true }));
  });
});
